export const ERROR_MESSAGES = {
  fetchDataError: "Error fetching Data:",
  postDataError: "Error for post data:",
};
